
import { LoginActionTypeKeys } from './loginActionTypes';

export const authenticateUser = (wsid: string, csrf: string, user: string) => {
  return { wsid, csrf, user, type: LoginActionTypeKeys.SIGNIN_SUCCESS } as ISignInSuccessAction;
};

export interface ISignInSuccessAction {
  readonly type: LoginActionTypeKeys.SIGNIN_SUCCESS;
  readonly wsid: string;
  readonly csrf: string;
  readonly user: string;
}

export const signOut = () => {
  return { type: LoginActionTypeKeys.SIGNOUT_SUCCESS } as ISignOutSuccessAction;
}

export interface ISignOutSuccessAction {
  readonly type: LoginActionTypeKeys.SIGNOUT_SUCCESS;
}

export const signInFailure = () => {
  return { type: LoginActionTypeKeys.SIGNIN_FAIL } as ISignInFailAction;
}

export interface ISignInFailAction {
  readonly type: LoginActionTypeKeys.SIGNIN_FAIL;
}


// WEBPACK FOOTER //
// ./src/actions/loginActions.ts